import UpdateFilterUrl from "./updatefilterurl.js";
import FilterValues from "./filtervalues.js";
import FilterMenu from "./filtermenu.js";
import SelectedFilters from "./selectedfilters.js";
import { prodListValues } from './shared.js';

const searchText = document.getElementById('txtInnerSearch');
const submit = document.getElementById('submitInnerSearch');
const mobileFilterDropDown = document.getElementById('filterDropDown');

class SubSearchFilter {
    /**
     * Initializes the sub-search filter by setting up event listeners for the submit button and the search text input.
     * @return {void}
     */
    events() {
        if (submit && searchText) {
            submit.addEventListener('click', (e) => {
                e.preventDefault();
                let subSearch = searchText.value;

                if (subSearch.length === 0) {
                    this.clear();
                    UpdateFilterUrl.update(FilterValues, prodListValues, false);
                } else {
                    if (this.checkForTagName(subSearch)) {
                        this.add(true);
                        UpdateFilterUrl.update(FilterValues, prodListValues, false);
                    } else {
                        searchText.value = '';
                    }
                }

                if (mobileFilterDropDown.classList.contains('active')) {
                    mobileFilterDropDown.click();
                }
            });
            
            searchText.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    submit.click();
                }
            });
        }
    };

    /**
     * Checks if the given term matches any tag name in the filter menu.
     * @param {string} term The term to check.
     * @return {boolean} True if the term matches a tag name, false otherwise.
     */
    checkForTagName(term) {
        FilterMenu.addTagFilters();

        return Array.from(FilterMenu.getMenuContainer.querySelectorAll('input[data-filter], button[data-filter]')).every((element) => {
            if (element.getAttribute('data-filter').toLowerCase() === term.toLowerCase()) {
                element.click();
                return false;
            }
            return true;
        });
    };

    /**
     * Adds a sub-search filter.
     * @param {boolean} logFilter Whether to log the filter addition.
     * @return {void}
     */
    add(logFilter) {
        let filterName = document.getElementById('SubSearchFilterTitle').value.replace('##search##', searchText.value);

        SelectedFilters.removeFromSelectedFilter(searchText);
        FilterValues.addSubSearchFilter(searchText.id, searchText.value, logFilter);
        searchText.value = '';
        SelectedFilters.addToSelectedFilter(searchText, filterName);
    };

    /**
     * Updates the sub-search filter with the given term.
     * @param {string} term The term to update the filter with.
     * @return {void}
     */
    update(term) {
        searchText.value = term;
        this.add(true);
    };

    /**
     * Clears the sub-search filter.
     * @return {void}
     */
    clear() {
        searchText.value = '';
        FilterValues.removeSubSearchFilter();
        SelectedFilters.removeFromSelectedFilter(searchText);
    };
}

export default new SubSearchFilter();